<template>
  <v-card>
      <v-card-text>

    <div class="prev">
      <img
        :src="$store.state.playlist.previewAds.link"
        alt=""
        v-if="$store.state.playlist.previewAds.type == 'Imagem'"
      />
      <video
        v-else-if="$store.state.playlist.previewAds.type == 'Vídeo' && $store.state.playlist.previewAds.link"
        :src="$store.state.playlist.previewAds.link"
        autoplay
        muted
        @ended="$emit('end')"
        ref="video"
      ></video>
      <Qr :color="$store.state.playlist.preview.color" v-if="$store.state.playlist.previewAds.showQr" />
      <div v-if="showLetreiroPreview" class="letreiro-overlay" :class="letreiroPositionClass">
        <Letreiro :text="letreiroText" />
      </div>
    </div>
      </v-card-text>
  </v-card>
</template>

<script>
import Qr from "./Qr.vue"
import Letreiro from '@/views/Letreiros/Letreiro.vue'
export default {
  components:{Qr, Letreiro},
  name: "PreviewsAds",
  props: ["anuncio", "onPlay"],
  computed: {
    activeItem() {
      return this.$store.state.playlist.itemsSelected[this.$store.state.playlist.playIndex] || {};
    },
    letreiroText() {
      const letreiro = this.$store.state.playlist.selectedLetreiro;
      return letreiro && letreiro.text ? letreiro.text : '';
    },
    showLetreiroPreview() {
      return !!this.letreiroText && !!this.activeItem.showLetreiro;
    },
    letreiroPositionClass() {
      const position = this.activeItem.letreiroPosition || 'TOPO';
      return position === 'RODAPÃ‰' ? 'letreiro-bottom' : 'letreiro-top';
    },
  },
  methods:{
    timeout(){
      return new Promise(resolve => setTimeout(resolve, 300))
    },
    async setPlaybackRate(){
      if(this.$refs.video){
        this.$refs.video.playbackRate = 1000 / this.$store.state.previews.timeout
        this.$refs.video.addEventListener("loadedmetadata", () => {
          this.$store.state.playlist.itemsSelected[this.$store.state.playlist.playIndex].time =  parseInt(this.$refs.video.duration)
        })
      }else{
        await this.timeout()
        await this.setPlaybackRate()
      }
    }
  },
  mounted(){
    this.setPlaybackRate()
    if(this.$store.state.playlist.itemsSelected[this.$store.state.playlist.playIndex]._id === "1133"){
      return
    }
    this.$store.state.playlist.previewAds = this.$store.state.playlist.itemsSelected[this.$store.state.playlist.playIndex]
    
  },
  watch:{
    onPlay(v){
      try {
        if(!v){
          this.$refs.video.pause()
        }else{
          //this.$refs.video.currentTime = 0
          this.$refs.video.play()
        }
      } catch (error) {
        console.error(error)
        return false
      }
    }
  }
};
</script>

<style scoped>
.prev {
    position: relative;
  width: 1080px;
  height: 1920px;
  zoom: .3;
}

.letreiro-overlay {
  position: absolute;
  left: 0;
  right: 0;
  z-index: 5;
}

.letreiro-top {
  top: 20px;
}

.letreiro-bottom {
  bottom: 20px;
}
video,
img {
  width: 1080px;
  height: 1920px;
}
.imgPrev{
    position:absolute;
    bottom: 200px;
    right: 100px;
    background: #fff;    
    width: 280px;
    height: 280px;
    border-radius: 50px;
    border: solid 10px #000;
    overflow: hidden;
    text-align: center;
}
.imgPrev img{
    
width: 180px;
height: 180px;
bottom: 0;
}
.leiamais{
  font-family: arial;
  text-align: center;
padding-bottom: 20px;
  font-weight: 900;
  font-size: 25pt;
  font-family: monospace;
}
</style>
